import { API_BASE } from '../utils/helpers';

const API_URL = `${API_BASE}/api/carrusel`;

const buildHeaders = (user) => {
  const headers = { 'Content-Type': 'application/json' };
  if (user?.id) headers['x-user-id'] = String(user.id);
  if (user?.role) headers['x-user-role'] = user.role;
  return headers;
};

const friendlyMessage = (message) => {
  const raw = String(message || '');
  if (/<!DOCTYPE html>|<html/i.test(raw)) {
    return 'La ruta /api/carrusel no esta disponible en el backend actual. Reinicia o despliega el backend actualizado.';
  }
  if (/String or binary data|truncated/i.test(raw)) {
    return 'Uno de los campos es demasiado largo';
  }
  return raw || 'No se pudo completar la solicitud';
};

async function handle(res) {
  const text = await res.text().catch(() => '');
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {}

  if (!res.ok) {
    throw new Error(friendlyMessage(data?.error || data?.message || text || `Error HTTP ${res.status}`));
  }

  return data || { success: true };
}

export async function obtenerCarrusel() {
  const res = await fetch(API_URL);
  return handle(res);
}

export async function obtenerCarruselAdmin() {
  const res = await fetch(`${API_URL}/admin`);
  return handle(res);
}

export async function crearImagenCarrusel(payload, user) {
  const res = await fetch(API_URL, {
    method: 'POST',
    headers: buildHeaders(user),
    body: JSON.stringify(payload)
  });
  return handle(res);
}

export async function actualizarImagenCarrusel(id, payload, user) {
  const res = await fetch(`${API_URL}/${id}`, {
    method: 'PUT',
    headers: buildHeaders(user),
    body: JSON.stringify(payload)
  });
  return handle(res);
}

export async function cambiarEstadoImagenCarrusel(id, activa, user) {
  const res = await fetch(`${API_URL}/${id}/estado`, {
    method: 'PATCH',
    headers: buildHeaders(user),
    body: JSON.stringify({ Activa: activa })
  });
  return handle(res);
}

export async function eliminarImagenCarrusel(id, user) {
  const res = await fetch(`${API_URL}/${id}`, {
    method: 'DELETE',
    headers: buildHeaders(user)
  });
  return handle(res);
}
